const SET_SHOW_BOOT_CAMPS_NAV_LINK = 'SET_SHOW_BOOTCAMPS_NAV_LINK';

export default SET_SHOW_BOOT_CAMPS_NAV_LINK;
